import React from 'react';
import { SearchIcon as SearchIconNS } from "@hm-group/fabric-icons/icons/SearchIcon";
import IconWrapper from '../IconWrapper';
const SearchIcon = (props) => {
    const brand = process.env.BRAND || process.env.BRAND_PREFIX;
    switch (brand) {
        case 'cos':
            return (React.createElement(IconWrapper, Object.assign({ viewBox: "0 0 14 14" }, props),
                React.createElement("path", { d: "M13.51 12.805L9.735 9.01a5.5 5.5 0 10-.725.725l3.795 3.775.705-.705zM1.01 5.51a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z" })));
        case 'northstar':
            return React.createElement(SearchIconNS, { className: props.className });
        default:
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "M11 2a9 9 0 0 1 6.866 14.82l-.159.18 4.243 4.243-.707.707L17 17.708A9 9 0 1 1 11 2zm0 1a8 8 0 1 0 0 16 8 8 0 0 0 0-16z" })));
    }
};
export default SearchIcon;
//# sourceMappingURL=SearchIcon.js.map